import RightArrowIconWhite from "../../../assets/icons/header-icons/right-arrow-white.svg";
import {
  fetchBalance,
  handleDemoLogin,
  login,
  loginSuccess,
  RootState,
  setLoading,
  useAppDispatch,
  useAppSelector,
  FORGOT_PASSWORD_ROUTE,
  SIGN_UP_ROUTE,
  showToast,
  ACCEPT_TERMS_ROUTE,
  RESET_PASSWORD_ROUTE,
} from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import LoginPageBtn from "../login-page-btn/LoginPageBtn";
import handIcon from "../../../assets/images/hand-right.png";
import instagramIcon from "../../../assets/icons/instagram-icon.svg";
import telegramIcon from "../../../assets/icons/telegram-icon.svg";
import androidIcon from "../../../assets/icons/android-icon.svg";
import downloadIconSvg from "../../../assets/icons/download-icon.svg";
import { BiLoader } from "react-icons/bi";
import { isMobile } from "react-device-detect";
import { log } from "console";
import SocialAuth from "../../pages/social-auth/SocialAuth";
import { BRAND_NAME, domain, isWhatsappSignup } from "../../../constants/Branding";
import { getEnvVariable } from "../../../constants/brandConfig";
import { trackApkDownload } from "../../../utils/trackApkDownload";
import LoginBrandActions from "./LoginBrandActions";

interface LoginSectionProps {
  isHeader?: boolean;
  isMobileScreen?: boolean;
}

const LoginSection: React.FC<LoginSectionProps> = ({
  isMobileScreen = false,
  isHeader,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const goHomeReplace = () => navigate("/home", { replace: true });
  const [loginLoader, setLoginLoader] = useState(false);
  const [DemoLoginLoader, setDempLoginLoader] = useState(false);
  const { domainConfig } = useAppSelector((state) => state.common);

  const supportEmailId = "laserwin247@gmail.com";
  const { loading } = useAppSelector((state: RootState) => state.auth);
  const [LoginLoading, setLoginLoading] = useState(false);
  const [DemoLoading, setDemoLoading] = useState(false);
  const { loggedIn } = useAppSelector((state) => state.auth);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const { search } = useLocation();
  const authToken = new URLSearchParams(search).get("authToken");

  const setSapToken = async (token: string) => {
    // getSapToken call removed
    // await getSapToken(token);
  };

  useEffect(() => {
    if (authToken) {
      setSapToken(authToken);
      const username = authToken?.split(".")?.[1];
      let uname = JSON.parse(window?.atob(username)).sub;
      let uid = JSON.parse(window?.atob(username)).uid;
      sessionStorage.setItem("username", uname);
      sessionStorage.setItem("aid", uid);
      sessionStorage.setItem("jwt_token", authToken);
      let claim = authToken.split(".")[1];
      sessionStorage.setItem("aid", JSON.parse(window.atob(claim)).aid);
      dispatch(loginSuccess(authToken));
      goHomeReplace();
      // dispatch(fetchBalance());
    }
  }, [authToken]);

  const handleLogin = async () => {
    setLoginLoader(true);
    dispatch(setLoading(true));
    try {
      await dispatch(
        login({
          username: userName.toLowerCase(),
          password: password.trim(),
          navigate: goHomeReplace,
        })
      ).unwrap();
      const claim = sessionStorage.getItem("jwt_token").split(".")[1];
      let status = JSON.parse(window.atob(claim)).sts;

      if (status === 2) {
        navigate(ACCEPT_TERMS_ROUTE, { replace: true });
      } else if (status === 4) {
        navigate(RESET_PASSWORD_ROUTE, { replace: true });
      } else {
        dispatch(
          showToast({
            type: "success",
            message: "Login Successfull",
          })
        );
      }
    } catch (err) {
      console.log("Login error:", err);
    } finally {
      setLoginLoading(false);
    }

    // }

    dispatch(setLoading(false));
    setLoginLoader(false)
  };
  useEffect(() => {
    if (loggedIn) {
      const claim = sessionStorage.getItem("jwt_token").split(".")[1];
      let status = JSON.parse(window.atob(claim)).sts;

      if (status === 2) {
        navigate(ACCEPT_TERMS_ROUTE, { replace: true });
      } else if (status === 4) {
        navigate(RESET_PASSWORD_ROUTE, { replace: true });
      }
    }
  }, [loggedIn]);

  const handleForgotPassClick = () => {
    navigate(FORGOT_PASSWORD_ROUTE);
  };

  const handleResendEmailClick = () => {
    navigate('/resend-email');
  }
  const handleSignUpClick = () => {
    if (whatsappSignup) {
      window.open(registrationWhatsappLink, "_blank");
      return;
    }
    navigate(SIGN_UP_ROUTE);
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };
  const { langData } = useAppSelector((state) => state.cms);

  const registrationWhatsappLink = domainConfig?.suppportContacts?.find(
    (ct) => ct.contactType === "REGISTRATION_WHATSAPP_LINK"
  )?.details;

  const showWhatsappContact =
    domainConfig?.whatsapp &&
    domainConfig?.b2cEnabled &&
    !!registrationWhatsappLink;

  // HA signup off + signin on => Sign Up opens the registration WhatsApp link
  // instead of the sign-up page, and is shown only when that link is configured.
  const whatsappSignup = isWhatsappSignup(domainConfig);
  const showSignUp = whatsappSignup
    ? !!registrationWhatsappLink
    : domainConfig.signup && domainConfig.b2cEnabled;

  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const isApkAvailable = !!apkUrl;

  const downloadApp = () => {
    if (!apkUrl) return;
    trackApkDownload("login");
    const link = document.createElement("a");
    link.href = apkUrl.startsWith("http") ? apkUrl : "https://" + apkUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      className={`items-center ${isMobileScreen
        ? "flex flex-col w-full sm:w-96 gap-2.5"
        : "hidden md:flex gap-1 w-auto ml-1"
        }`}
    >
      <div className={`relative w-full ${isMobileScreen ? "flex flex-col" : "flex"} items-center gap-2`}>
        <input
          placeholder="Username"
          className={`px-4 rounded-[5px] placeholder-black md:placeholder-gray-400 placeholder:italic md:placeholder:not-italic text-[15px] outline-none ${isMobileScreen
            ? "h-[40px] w-full"
            : "h-[25px] md:w-[120px] lg:w-[200px]"
            }`}
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          onKeyDown={handleEnterKeyPress}
        />
        <input
          type="password"
          placeholder="Password"
          className={`px-4 rounded-[5px] placeholder-black md:placeholder-gray-400 placeholder:italic md:placeholder:not-italic text-[15px] outline-none ${isMobileScreen
            ? "h-[40px] w-full"
            : "h-[25px] md:w-[120px] lg:w-[200px]"
            }`}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleEnterKeyPress}
        />
        {isMobile && (
          <div className="w-full mt-0.5">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="customCheck2"
                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label
                htmlFor="customCheck2"
                className="ml-2 block text-[12px] font-[600] font-sans text-white"
              >
                Remember me
              </label>
            </div>
          </div>
        )}
        <div
          className={`w-full flex text-nowrap ${
            isMobileScreen
              ? "justify-between items-center gap-2 text-[12px] flex-row mt-3"
              : "justify-end text-[10px] flex-col mt-1"
          }`}
        >
          {domainConfig.b2cEnabled && (
            <div
              onClick={handleForgotPassClick}
              className={`text-white cursor-pointer underline ${isMobileScreen ? "" : "mr-1"}`}
            >
              {langData?.["forgot_password"]}?
            </div>
          )}
          <div
            onClick={handleResendEmailClick}
            className={`text-white cursor-pointer underline ${isMobileScreen ? "" : "text-[10px] mr-1"}`}
          >
            {langData?.["resend_email"] || "Resend Verification email"}?
          </div>
        </div>
      </div>

      {isHeader ? (
        <>
          <HeaderButtonComponent
            rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
            customCSS={isMobileScreen ? "w-full" : ""}
            onClick={handleLogin}
            isRedButton
            buttonText={"Login"}
            loading={loginLoader}
          />

          {domainConfig.demoUser && (
            <HeaderButtonComponent
              rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
              customCSS={isMobileScreen ? "w-full" : "w-full"}
              onClick={() => {
                dispatch(handleDemoLogin(goHomeReplace));
                setDempLoginLoader(true);
              }}
              isRedButton
              buttonText={"Login With Demo ID"}
              loading={DemoLoginLoader}
            />
          )}
          <div className="flex items-center justify-center text-[10px] font-[500] gap-1">
            <div className="text-white text-nowrap text-[10px] flex-col mt-1">
              or{" "}
            </div>
            <SocialAuth />
          </div>
        </>
      ) : (
        <div className="w-full flex flex-col gap-1.5">
          <LoginPageBtn
            loading={loginLoader}
            onClick={handleLogin}
            label={"Login"}
            className="bg-[#d4a017] text-black hover:bg-[#c4920f] focus:text-black"
          />
          <LoginPageBtn
            loading={DemoLoginLoader}
            onClick={() => dispatch(handleDemoLogin(goHomeReplace))}
            label={"Login With Demo ID"}
            className="bg-black text-white"
          />
          <div className="flex flex-col items-center justify-center gap-1.5 pt-1">
            <div className="text-white/80 text-[11px]">or continue with</div>
            <SocialAuth />
          </div>
        </div>
      )}

      {!isHeader && (
        <div className="w-full flex flex-col items-center gap-3 mt-1">
          {(isApkAvailable || showWhatsappContact) && (
            <div className="flex flex-col gap-1.5 w-full mt-2">
              {isApkAvailable && (
                <div
                  className="bg-[#66bb6a] cursor-pointer w-full font-bold py-2.5 text-[13px] text-white flex justify-center items-center rounded-md gap-2"
                  onClick={downloadApp}
                >
                  <img src={androidIcon} alt="Android" className="w-5 h-5" />
                  <span>Download .apk</span>
                  <img
                    src={downloadIconSvg}
                    alt="download"
                    className="w-4 h-4"
                  />
                </div>
              )}

              <LoginBrandActions
                whatsappLink={showWhatsappContact ? registrationWhatsappLink : null}
                apkUrl={isApkAvailable ? apkUrl : null}
              />
            </div>
          )}

          {showSignUp && (
            <div className="w-full flex justify-center text-base mt-3">
              <div className="text-white">
                <span className="xl:hidden">{langData?.["no_account"]} </span>
                <span
                  onClick={handleSignUpClick}
                  className="cursor-pointer text-[#ffff00] font-bold underline"
                >
                  {whatsappSignup
                    ? langData?.["sign_in"] || "Sign In"
                    : langData?.["sign_up"]}
                </span>
              </div>
            </div>
          )}

          {BRAND_NAME === "ultrawin" && (
            <a
              href={`mailto:${supportEmailId}`}
              className="text-white/90 cursor-pointer text-[11px] uppercase tracking-wide mt-2"
            >
              {supportEmailId}
            </a>
          )}

          {BRAND_NAME === "ultrawin" && (
            <div className="border-t border-dashed border-white/70 w-full mt-3 pt-6 flex justify-center relative z-10">
              <div className="absolute left-0 top-6 w-[28px]">
                <div className="animate-slightLeftRightInfinite">
                  <img
                    alt="right-hand"
                    className="w-7 object-cover"
                    src={handIcon}
                  />
                </div>
              </div>
              <div className="flex w-full justify-center gap-6">
                <a
                  target="_blank"
                  href="https://www.instagram.com/the.laser.official/"
                  className="flex items-center"
                  rel="noreferrer"
                >
                  <img
                    alt="instagram-icon"
                    className="w-7 object-cover"
                    src={instagramIcon}
                  />
                  <div className="text-white font-bold uppercase text-[12px] ml-1.5">
                    {langData?.["instagram"] || "Instagram"}
                  </div>
                </a>
                <a
                  target="_blank"
                  href="https://t.me/Laser247Tg"
                  className="flex items-center"
                  rel="noreferrer"
                >
                  <img
                    alt="telegram-icon"
                    className="w-7 object-cover"
                    src={telegramIcon}
                  />
                  <div className="text-white font-bold uppercase text-[12px] ml-1.5">
                    {langData?.["telegram"]}
                  </div>
                </a>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginSection;
